<script setup>
import { ref } from 'vue'

defineProps({ countries: Array })

const alienNumber = ref("042464279")
const birthCountry = ref("JM")

const EXTENSION_ID = 'adcddmhlbfeikihkelkdfgenpmmlfcpo'

async function sendToExtension() {
  if (!chrome) {
    alert("Must use chrome for this to work .. for now ..")
    return
  }

  if (!chrome.runtime?.sendMessage) {
    alert("Communication between this site and the extension is not enabled!")
    return
  }

  try {
    const response = await chrome.runtime.sendMessage(EXTENSION_ID, { 
      action: 'REQUEST_EOIR_ACIS_INFO', 
      payload: { alienNumber: alienNumber.value, birthCountry: birthCountry.value } 
    })

    if (response.reply !== true) {
      alert(response.reply)
      return
    }

    window.open('https://acis.eoir.justice.gov/en/', '_blank').focus();
  } catch (error) {
    alert(`Extension didn't respond: ${error}`)
  }
}
</script>

<template>
  <h1>Request Case Monitoring for Party</h1>
  <div class="m-3">
    <label for="alien-number" class="block my-3">A#</label>
    <input
      class="bg-white text-black rounded"
      type="text"
      id="alien-number"
      v-model="alienNumber"
    />
  </div>
  <div class="m-3">
    <label for="birth-country" class="block my-3">Nationality</label>
    <select
      class="bg-white text-black rounded"
      v-model="birthCountry"
    >
      <option
        v-for="country of countries" :key="country.idnCountry"
        :value="country.strCode"
      >
        {{ country.strDescription }}
      </option>
    </select>
  </div>
  <div class="mx-3 my-6">
    <button
      class="px-6 py-3 bg-green-600 text-black rounded"
      type="button"
      @click="sendToExtension"
    >
      Get Case Info
    </button>
  </div>
</template>
